import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store';
import { confirmPrompt } from '@/utilities';

// Pages: Account
import Home from '@/views/Home.vue';
import CompleteNewPassword from '@/views/CompleteNewPassword.vue';
import ConfirmEmail from '@/views/ConfirmEmail.vue';
import ResetPassword from '@/views/ResetPassword.vue';


// Customers
import CustomerList from '@/pages/customers/CustomerList.vue';
import CustomerDetail from '@/pages/customers/CustomerDetail.vue';

// Maintenancejobs
import JobList from '@/pages/jobs/JobList.vue';
import JobDetail from '@/pages/jobs/JobDetail.vue';
import JobDetailsTab from '@/pages/jobs/tabs/JobDetails.vue';
// import DatesTab from '@/pages/jobs/tabs/Dates.vue';
import TasksTab from '@/pages/jobs/tabs/Tasks.vue';
import CustomerTab from '@/pages/jobs/tabs/Customer.vue';
import QuotationTab from '@/pages/jobs/tabs/Quotation.vue';
import InvoiceTab from '@/pages/jobs/tabs/Invoice.vue';
import ContractorTab from '@/pages/jobs/tabs/Contractor.vue';

// Contractor
import ContractorList from '@/pages/contractors/ContractorList.vue';
import ContractorDetail from '@/pages/contractors/ContractorDetail.vue';
import InspectorList from '@/pages/inspectors/InspectorList.vue';
import InspectorDetail from '@/pages/inspectors/InspectorDetail.vue';
import Emailhistory from '@/pages/emailmaintenancejobhistory/index.vue';

// Invoices
import Invoices from '@/pages/invoices/index.vue';
import EditInvoice from '@/pages/invoices/Invoice.vue';
import InvoiceDetailData from '@/pages/invoices/InvoiceDetail.vue';
import PaymentDetailsTab from '@/pages/invoices/PaymentDetails.vue';

// Account settings
import AccountSettings from '@/accountsettings/index.vue';

Vue.use(Router);

/**
 * Defining each path in the CMS
 */
const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0,
    };
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        requiresAuth: false,
        breadcrumb: 'Dashboard'
      },
    },
    {
      path: '/sign-in',
      name: 'sign-in',
      component: Home,
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: '/sign-out',
      name: 'sign-out',
      component: Home,
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: '/reset-password',
      name: 'reset-password',
      component: ResetPassword,
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: '/complete-new-password',
      name: 'complete-new-password',
      component: CompleteNewPassword,
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: '/confirm-email',
      name: 'confirm-email',
      component: ConfirmEmail,
      meta: {
        requiresAuth: false,
      },
    },

    {
      path: '/maintenancejobs',
      name: 'maintenancejobs',
      component: JobList,
      meta: {
        requiresAuth: true,
        requiresGroup: [
          'Administrators',
          'BaseUser',
          'AdvanceUser'
        ],
        breadcrumb: 'Dashboard'
      },
    },
    {
      path: '/maintenancejobs/:id',
      name: 'edit-maintenancejob',
      redirect: '/maintenancejobs/:id/jobdetails',
      component: JobDetail,
      meta: {
        requiresAuth: true,
        requiresGroup: [
          'Administrators',
          'BaseUser',
          'AdvanceUser'
        ],
        breadcrumb: {
          parent: 'maintenancejobs',
          label: ''
        }
      },
      children: [
        {
          path: 'jobdetails',
          name: 'job-jobdetails',
          component: JobDetailsTab,
          meta: {
            requiresAuth: true,
            requiresGroup: [
              'Administrators',
              "BaseUser",
              'AdvanceUser'
            ],
            breadcrumb: 'JobDetails'
          }
        },
        {
          path: 'tasks',
          name: 'job-taskes',
          component: TasksTab,
          meta: {
            requiresAuth: true,
            requiresGroup: [
              'Administrators',
              'AdvanceUser',
              "BaseUser"
            ],
            breadcrumb: 'Tasks'
          }
        },
        // {
        //   path: 'dates',
        //   name: 'job-dates',
        //   component: DatesTab,
        //   meta: {
        //     requiresAuth: true,
        //     requiresGroup: [
        //       'Administrators',
        //       'AdvanceUser'
        //     ],
        //     breadcrumb: 'Dates'
        //   }
        // },
        // {
        //   path: 'customer',
        //   name: 'job-customer',
        //   component: CustomerTab,
        //   meta: {
        //     requiresAuth: true,
        //     requiresGroup: [
        //       'Administrators',
        //       'AdvanceUser'
        //     ],
        //     breadcrumb: 'Customer'
        //   }
        // },
        {
          path: 'quotation',
          name: 'job-quotation',
          component: QuotationTab,
          meta: {
            requiresAuth: true,
            requiresGroup: [
              'Administrators',
              'AdvanceUser'
            ],
            breadcrumb: 'Quotation'
          }
        },
        {
          path: 'invoice',
          name: 'job-invoice',
          component: InvoiceTab,
          meta: {
            requiresAuth: true,
            requiresGroup: [
              'Administrators',
              'AdvanceUser'
            ],
            breadcrumb: 'Invoice'
          }
        },
        // {
        //   path: 'contractor',
        //   name: 'job-contractor',
        //   component: ContractorTab,
        //   meta: {
        //     requiresAuth: true,
        //     requiresGroup: [
        //       'Administrators',
        //       'AdvanceUser'
        //     ],
        //     breadcrumb: 'Contractor'
        //   }
        // },
      ],
    },

    {
      path: '/customers',
      name: 'customers',
      component: CustomerList,
      meta: {
        requiresAuth: true,
        requiresGroup: [
          'Administrators',
          'AdvanceUser'
        ],
        breadcrumb(params: any) {
          return {
            parent: 'maintenancejobs',
            label: 'Customers'
          }
        }
      }
    },
    {
      path: '/customers/:id',
      name: 'edit-customer',
      component: CustomerDetail,
      meta: {
        requiresAuth: true,
        requiresGroup: [
          'Administrators',
          'AdvanceUser'
        ],
        breadcrumb(params: any) {
          return {
            parent: 'customers',
            label: 'Customer details'
          }
        }
      }
    },
    {
      path: '/contractors',
      name: 'contractors',
      component: ContractorList,
      meta: {
        requiresAuth: true,
        breadcrumb(params: any) {
          return {
            parent: 'maintenancejobs',
            label: 'Contractors'
          }
        }
      }
    },
    {
      path: '/contractors/:id',
      name: 'edit-contractors',
      component: ContractorDetail,
      meta: {
        requiresAuth: true,
        breadcrumb(params: any) {
          return {
            parent: 'contractors',
            label: 'Contractor details'
          }
        }
      }
    },

    {
      path: '/inspectors',
      name: 'inspectors',
      component: InspectorList,
      meta: {
        requiresAuth: true,
        breadcrumb(params: any) {
          return {
            parent: 'maintenancejobs',
            label: 'Inspectors'
          }
        }
      }
    },
    {
      path: '/inspectors/:id',
      name: 'edit-inspectors',
      component: InspectorDetail,
      meta: {
        requiresAuth: true,
        breadcrumb(params: any) {
          return {
            parent: 'inspectors',
            label: 'Inspector details'
          }
        }
      }
    },


    {
      path: '/viewemailmaintenancejobhistory/:id',
      name: 'viewemailmaintenancejobhistory',
      component: Emailhistory,
      meta: {
        requiresAuth: true,
        unsavedChangesWarning: true,
        breadcrumb(params: any) {
          return {
            parent: 'maintenancejobs',
            label: ''
          }
        }
      },
    },
    {
      path: '/invoices',
      name: 'invoices',
      component: Invoices,
      meta: {
        requiresAuth: true,
        requiresGroup: [
          'Administrators',
          'BaseUser',
          'AdvanceUser'
        ],
        breadcrumb: 'Dashboard'
      },
    },
    {
      path: '/invoice/:id',
      name: 'edit-invoice',
      redirect: '/invoice/:id/invoicedetails',
      component: InvoiceDetailData,
      meta: {
        requiresAuth: true,
        requiresGroup: [
          'Administrators',
          'BaseUser',
          'AdvanceUser'
        ],
        breadcrumb: {
          parent: 'invoices',
          label: ''
        }
      },
      children: [
        {
          path: 'invoicedetails',
          name: 'edit-job-invoice',
          component: EditInvoice,
          meta: {
            requiresAuth: true,
            requiresGroup: [
              'Administrators',
              "BaseUser",
              'AdvanceUser'
            ],
            breadcrumb: 'Invoice  Details'
          }
        },
        {
          path: 'payment-details',
          name: 'payment-details',
          component: PaymentDetailsTab,
          meta: {
            requiresAuth: true,
            requiresGroup: [
              'Administrators',
              "BaseUser",
              'AdvanceUser'
            ],
            breadcrumb: 'Payment Details'
          }
        },
      ]
    },
		{
			path: '/accountsettings',
			name: 'accountsettings',
			component: AccountSettings,
			meta: {
        requiresAuth: true,
      },
		},
  ],
});

/**
 * Global guard to check if we are signed in with Cognito
 */
router.beforeResolve(async (to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {

    try {

      const data = await Vue.prototype.$Amplify.Auth.currentAuthenticatedUser();

      if (data && data.signInUserSession) {
        store.commit('auth/setCognitoUser', data);
      }

      const assignedGroups = store.getters['auth/groups'];
      const nearestWithGroup = to.matched.slice().reverse().find(r => r.meta && r.meta.requiresGroup);
      if (nearestWithGroup && Array.isArray(nearestWithGroup.meta.requiresGroup)) {
        const isAllowedAccess = assignedGroups.some((assignedGroup: string) => nearestWithGroup.meta.requiresGroup.includes(assignedGroup));
        if (false === isAllowedAccess) {
          throw Error('You are not unauthorised to access that resource.');
        }
      }

      next();
    } catch (err) {
      console.error('router.beforeResolve', err);

      if (err.message) {
        Vue.toasted.error(err.message);
      }

      await Vue.prototype.$Amplify.Auth.signOut();

      store.commit('auth/setCognitoUser', null);
      console.log("DIRECT LOGIN");
      next({
        path: '/sign-in',
        query: { redirect: to.fullPath },
      });
    }
  } else {
    next();
  }
});

/**
 * Global guard to confirm leaving a route with unsaved changes
 */
router.beforeEach(async (to, from, next) => {
  // This allows us to set `meta.unsavedChangesWarning` on parent routes
  const topmostFromRoute = from.matched[0];
  const topmostToRoute = to.matched[0];

  if (topmostFromRoute === undefined) {
    console.log('"From" route is empty');
    next();
  } else if (topmostToRoute === undefined) {
    console.log('"To" route is empty');
    next();
  } else if (topmostFromRoute.name === topmostToRoute.name) {
    console.log('Topmost route has not changed');
    next();
  } else if (!topmostFromRoute.meta.unsavedChangesWarning) {
    console.log('No "Unsaved changes" warning for route you left');
    next();
  } else if (store.getters['customers/hasUnsavedChanges']) {
    console.log('Unsaved changes found: display prompt');

    try {
      await confirmPrompt('You have unsaved changes. Do you want to continue without saving your changes?');

      // confirmPrompt() throws an error on Cancel, so the following lines
      // will only execute if OK has been selected
      store.commit('customers/resetUnsavedChanges');
      store.commit('maintenancejobs/resetUnsavedChanges');
      next();
    } catch (data) {
      next(false);
    }
  } else {
    console.log('NO unsaved changes found: continue without prompting');
    next();
  }
});

export default router;
